import { atom } from 'jotai';

import { LocationInput } from '@/__generated__/businessLocationsMutation.graphql';
import { LocationFormType, LocationModel, LocationType } from '@/lib/types/survey';

export const displayBusinessNameAtom = atom('');
export const isCompletedCurrentBusinessSurveyAtom = atom(false);

// Location
// id가 없어 client schema / server schema 따로 관리
export const locationsDataAtom = atom<LocationModel>({
  hometaxAddress: '',
  openingDate: '',
  isFirstLocation: 'blank',
  locations: [],
  isStartBusinessDirectly: false
});

export const readonlyIsFirstLocationAtom = atom((get) => get(locationsDataAtom).isFirstLocation);
export const readonlyLocationsForServerAtom = atom<LocationInput[]>((get) => {
  const locations = get(locationsDataAtom).locations;
  return locations.map(({ isFirstLocation, isUnknownRelocationYear, year, address }) => ({ isFirstLocation, isUnknownRelocationYear, year, address }));
});
export const readonlyHometaxAddressIndexAtom = atom((get) => {
  const data = get(locationsDataAtom);
  return data.locations.findIndex(({ address }) => address === data.hometaxAddress);
});
export const readonlyHometaxAddressLocationAtom = atom<LocationType>((get) => {
  const data = get(locationsDataAtom);
  const locations = data.locations;
  return (
    locations.find(({ address }) => address === data.hometaxAddress) || {
      year: locations[0]?.year || 0,
      address: locations[0]?.address || '',
      isFirstLocation: locations[0]?.isFirstLocation || 'blank',
      isUnknownRelocationYear: !!locations[0]?.isUnknownRelocationYear,
      isHometaxRegAddress: !!locations[0]?.isHometaxRegAddress
    }
  );
});

export const someIsFirstLocationAtom = atom((get) => get(locationsDataAtom).locations.some(({ isFirstLocation }) => isFirstLocation === 'yes'));
export const locationFormAtom = atom<LocationFormType>({
  index: -1,
  year: 0,
  isFirstLocation: 'no',
  city: ''
});
